<template>
  <div class="viet-qr-payment d-inline-flex flex-column align-items-start gap-2">
    <vue-qrcode v-if="!hideQr && showVueQrcode"
                :value="payload"
                tag="svg"
                class="viet-qr-payment__qr"
                style="width: 100%; border-radius: 10px"
                :options="{ width: '200px' }"/>
    <div v-if="showVueQrcode" class="d-flex flex-wrap align-items-start gap-2">
      <copy-button :value="payload" class="ms-1 d-flex">
        <small class="text-secondary text-capitalize-first">{{ helper.trans('labels.raw_field.qrString') }}</small>
      </copy-button>
    </div>
    <img v-else-if="imageUrl"
         :src="imageUrl"
         alt=""
         class="viet-qr-payment__img"/>
    <span v-else-if="fallbackRequisites">{{ fallbackRequisites }}</span>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, onUnmounted, ref, watch} from 'vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import {api} from '@/service/APIClient'
import {helper} from '@/service/CommonHelper'
import CopyButton from "@/apps/public/components/CopyButton.vue";

const isUrlOrData = (s: string) => /^https?:\/\//i.test(s) || s.startsWith('data:')

export default defineComponent({
  name: 'VietQrPaymentBlock',
  components: {VueQrcode, CopyButton},
  props: {
    hideQr: {type: Boolean, required: false},
    dealId: {type: String, required: true},
    qrCodeData: {type: String, default: null},
    qrCodeLink: {type: String, default: null},
    fallbackRequisites: {type: String, default: null},
  },
  setup(props) {
    const blobUrl = ref<string | null>(null)

    const payload = computed(() => (props.qrCodeData ?? props.qrCodeLink ?? '').trim())

    const showVueQrcode = computed(() => {
      const q = payload.value
      return !!q && !isUrlOrData(q)
    })

    const imageUrl = computed(() => {
      const q = payload.value
      return q && isUrlOrData(q) ? q : blobUrl.value
    })

    watch(
      () => [props.dealId, props.qrCodeData, props.qrCodeLink] as const,
      async () => {
        if (blobUrl.value) {
          URL.revokeObjectURL(blobUrl.value)
          blobUrl.value = null
        }
        const q = payload.value
        if (q || !props.dealId) {
          return
        }
        try {
          const blob = await api.dealQrCodeBlob(props.dealId)
          blobUrl.value = URL.createObjectURL(blob)
        } catch {
          blobUrl.value = null
        }
      },
      {immediate: true}
    )

    onUnmounted(() => {
      if (blobUrl.value) {
        URL.revokeObjectURL(blobUrl.value)
      }
    })

    return {showVueQrcode, imageUrl, payload, helper}
  },
})
</script>

<style scoped>
.viet-qr-payment__img {
  max-width: 220px;
  height: auto;
}
</style>
